import styled from 'styled-components';

import { getFormsTemplatesSectionsGap } from './FormsTemplates.styled';

const SCROLL_WIDTH = '8px';

export const StyledFormsTemplatesMainContentSection = styled.section`
   width: calc(100% - 388px - ${getFormsTemplatesSectionsGap()} - ${SCROLL_WIDTH});
   height: 100%;
`;
StyledFormsTemplatesMainContentSection.displayName = 'StyledFormsTemplatesMainContentSection';
